import { AdditionalFilters } from '../hooks/useHomeFeed';

export const parseCachedAdditionalFilters = (value: AdditionalFilters): AdditionalFilters => {
    if (!value?.lastUpdatedRange) {
        return value;
    }

    return {
        ...value,
        lastUpdatedRange: {
            start: new Date(value.lastUpdatedRange.start),
            end: new Date(value.lastUpdatedRange.end),
        },
    };
};

export const normalizeAdditionalFilters = (filters: AdditionalFilters): AdditionalFilters => {
    if (!filters.lastUpdatedRange) return filters;

    return {
        ...filters,
        lastUpdatedRange: {
            start: new Date(filters.lastUpdatedRange.start),
            end: new Date(filters.lastUpdatedRange.end),
        },
    };
};

export const areAdditionalFiltersEqual = (a: AdditionalFilters, b: AdditionalFilters): boolean => {
    const normalizedA = normalizeAdditionalFilters(a);
    const normalizedB = normalizeAdditionalFilters(b);
    return JSON.stringify(normalizedA) === JSON.stringify(normalizedB);
};

export const areLocationSelectionsEqual = (
    a: Array<string> | 'all',
    b: Array<string> | 'all'
): boolean => {
    if (a === 'all' || b === 'all') {
        return a === b;
    }
    if (a.length !== b.length) {
        return false;
    }

    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((value, index) => value === sortedB[index]);
};
